import { mergeApplicationConfig, ApplicationConfig } from '@angular/core';
import { appConfig } from './app.config';
import { provideHtmlParserService, HtmlParserBrowserService, provideDeviceTypeService, DeviceTypeBrowserService, UserLocaleBrowserService, provideUserLocaleService } from '@knorr-bremse-portals/ngx-components';
import { DialogPolyfillBrowserService } from './providers/dialog-polyfill.browser.service';
import { provideDialogPolyfillService } from './providers/dialog-polyfill.service';
import { PERFORMANCE } from '../express.tokens';
import { provideBaseLocationService } from './providers/base-location.service';
import { BaseLocationBrowserService } from './providers/base-location.service.browser';

const config: ApplicationConfig = {
  providers: [
    provideDialogPolyfillService(DialogPolyfillBrowserService),
    provideHtmlParserService(HtmlParserBrowserService),
    provideDeviceTypeService(DeviceTypeBrowserService),
    provideUserLocaleService(UserLocaleBrowserService),
    provideBaseLocationService(BaseLocationBrowserService),
    { provide: PERFORMANCE, useValue: window.performance },
  ],
};

export const browserConfig = mergeApplicationConfig(appConfig, config);
